export const XA = 'XA';
